/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from '@/components/cusPagination.vue';
import {orderGet,orderSeach} from "@/api/order"
import {fileEcho, shopDetail} from "@/api/url"
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            loading:true,
            searchForm: {
                orderNo: '',
                goodsName: '',
                goodsUnionld: '',
                storeName: '',
                name:'',
                buyerName: '',
                deliveryMode: '',
                state: '',
                createdDate: '',
            },
            stateText:'',
            tableData:[],
            tableDataLoc: fileEcho,
            tabsCut: 0,//页头切换
            currentPage: 1,
            pageSize: 10,
            total:0,
        };
    },
    // 自定义方法
    methods: {
        //搜索
        seachBtn() {
            console.log(this.searchForm);
            this.getList();
        },
        //重置
        resetBtn() {
            this.searchForm.orderNo = '';
            this.searchForm.goodsName = '';
            this.searchForm.goodsUnionld = '';
            this.searchForm.storeName = '';
            this.searchForm.name = '';
            this.searchForm.buyerName = '';
            this.searchForm.deliveryMode = '';
            this.searchForm.state = '';
            this.searchForm.createdDate = '';
            this.cutCreatedDate = '';
            this.getList();
        },
        //获取数据
        getList() {
            if (this.searchForm.createdDate.length > 0) {
                this.cutCreatedDate = (this.searchForm.createdDate[0] + ',' + this.searchForm.createdDate[1])
            }
            this.loading = true;
            this.$ajax.get(orderGet, {
                orderNo: this.searchForm.orderNo,
                goodsName: this.searchForm.goodsName,
                goodsUnionld: this.searchForm.goodsUnionld,
                name:this.searchForm.name,
                storeName:this.searchForm.storeName,
                buyerName: this.searchForm.buyerName,
                deliveryMode: this.searchForm.deliveryMode,
                state: this.searchForm.state || this.stateText,
                createdDate: this.cutCreatedDate,
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.loading = false;
                }
            }, (err) => {
                console.log(err);
            })
        },
        cut(num) {
            console.log(num);
            if (num == 0){
                this.tabsCut = 0;
                this.stateText = '';
                this.getList();
            }else if (num == 1){
                this.tabsCut = 1;
                this.stateText = 'TOPAY';
                this.getList();
            }else if (num == 2){
                this.tabsCut = 2;
                this.stateText = 'TOSHIP';
                this.getList();
            }else if (num == 3){
                this.tabsCut = 3;
                this.stateText = 'SHIPPED';
                this.getList();
            }else if (num == 4){
                this.tabsCut = 4;
                this.stateText = 'CONFIRMED';
                this.getList();
            }else if (num == 5){
                this.tabsCut = 5;
                this.stateText = 'CANCELED';
                this.getList();
            }
        },
        detailsBtn(item){
            let id = window.btoa(item.id);
            this.$router.push({path: '/orderDetail', query: {id: id}});
        }
    },
    // 数据观察监听
    watch: {
        currentPage(newData,oldData){
            this.getList()
        },
        pageSize(newData,oldData){
            this.getList()
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        if(this.$route.query.shopId!=undefined){
            this.$ajax.get(shopDetail(this.$route.query.shopId),{id:this.$route.query.shopId}).then(res=>{
                console.log(res);
                this.searchForm.storeName = res.data.name;
                if (this.$route.query.type != undefined) {
                    if (this.$route.query.type == ''){
                        this.tabsCut = 0;
                        this.stateText = '';
                        this.getList();
                    }else if (this.$route.query.type == 'TOPAY'){
                        this.tabsCut = 1;
                        this.stateText = 'TOPAY';
                        this.getList();
                    }else if (this.$route.query.type == 'TOSHIP'){
                        this.tabsCut = 2;
                        this.stateText = 'TOSHIP';
                        this.getList();
                    }else if (this.$route.query.type == 'SHIPPED'){
                        this.tabsCut = 3;
                        this.stateText = 'SHIPPED';
                        this.getList();
                    }else if (this.$route.query.type == 'CONFIRMED'){
                        this.tabsCut = 4;
                        this.stateText = 'CONFIRMED';
                        this.getList();
                    }else if (this.$route.query.type == 'CANCELED'){
                        this.tabsCut = 5;
                        this.stateText = 'CANCELED';
                        this.getList();
                    }
                }
                this.getList()
            },err=>{
                console.log(err);
            })
        }else{
            this.getList()
        }

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
